import { HomeModule } from './home/home.module';
import { AccessModule } from './access/access.module';
import { BaseComponent } from './base.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';


@NgModule({
	declarations: [
		BaseComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		AccessModule,
		HomeModule,
		SharedModule
	],
	exports: [
		BaseComponent,
		AccessModule
	]
})
export class BaseModule {
}
